import { useOrganization, useUser } from "@clerk/react-router";
import { posthog } from "posthog-js";
import { useEffect } from "react";
import { shouldCapturePostHogExceptions } from "~/app/lib/posthog";

export function PosthogInit() {
  useEffect(() => {
    const productionHosts = new Set([
      "anylawyer.com",
      "www.anylawyer.com",
      "container.anylawyer.com",
    ]);
    const releaseVersion = import.meta.env.VITE_POSTHOG_RELEASE_VERSION;

    posthog.init("phc_huKSxI8BZD1rvbdi8OaAbEdN63eVl9wcxSaQLw6e3H3", {
      api_host: "https://eu.i.posthog.com",
      person_profiles: "identified_only",
      autocapture: false,
      capture_pageview: false,
      capture_exceptions: shouldCapturePostHogExceptions()
        ? {
            capture_console_errors: false,
            capture_unhandled_errors: true,
            capture_unhandled_rejections: true,
          }
        : false,
    });

    if (releaseVersion) {
      posthog.register({
        app_release: releaseVersion,
      });
    }

    if (productionHosts.has(location.hostname)) {
      posthog.opt_in_capturing();
    }
  }, []);

  return null;
}

export function PosthogUser() {
  const { user, isLoaded: userLoaded } = useUser();
  const { organization, membership, isLoaded: orgLoaded } = useOrganization();

  useEffect(() => {
    if (userLoaded && orgLoaded && user) {
      posthog.identify(user.id, {
        email: user.primaryEmailAddress?.emailAddress,
        currentOrgId: organization?.id,
        currentOrgName: organization?.name,
        currentOrgRole: membership?.role,
      });
    } else if (userLoaded && !user) {
      posthog.reset();
    }
  }, [userLoaded, orgLoaded, user, organization, membership]);

  return null;
}
